import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCourses = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 29,
	viewBox: "0 0 42 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.24 15.0675C12.86 14.8875 12.42 15.0575 12.24 15.4275C12.06 15.8075 12.23 16.2475 12.6 16.4275L20.43 20.0775C20.53 20.1275 20.64 20.1475 20.75 20.1475C20.86 20.1475 20.97 20.1275 21.07 20.0775L28.9 16.4275C29.28 16.2575 29.44 15.8075 29.26 15.4275C29.09 15.0475 28.64 14.8875 28.26 15.0675L20.75 18.5675L13.24 15.0675Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M41.07 9.3975L21.07 0.0675C20.87 -0.0225 20.64 -0.0225 20.44 0.0675L0.43 9.3975C0.17 9.5175 0 9.7875 0 10.0775C0 10.3675 0.17 10.6375 0.43 10.7575L7.5 14.0575V22.4375C7.5 22.6375 7.58 22.8175 7.71 22.9575C11.19 26.5275 15.82 28.4875 20.75 28.4875C25.68 28.4875 30.3 26.5275 33.79 22.9575C33.93 22.8175 34 22.6275 34 22.4375V14.0575L41.07 10.7575C41.33 10.6375 41.5 10.3675 41.5 10.0775C41.5 9.7875 41.33 9.5175 41.07 9.3975ZM32.93 12.8975C32.67 13.0175 32.5 13.2875 32.5 13.5775V22.1275C29.33 25.2675 25.17 26.9875 20.75 26.9875C16.33 26.9875 12.17 25.2575 9 22.1275V13.5775C9 13.2875 8.83 13.0175 8.57 12.8975L2.53 10.0775L20.76 1.5775L38.99 10.0775L32.95 12.8975H32.93Z",
		fill: "currentColor"
	})]
});
export default SvgCourses;
